import React from "react";
import { Calendar, Home, Store } from "lucide-react";

interface NavigationButtonsProps {
  lojasCount: number;
  onGoHome?: () => void;
  onToggleLojaSelector?: () => void;
  selectedDateISO?: string;
  onSelectedDateChange?: (iso: string) => void;
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  lojasCount,
  onGoHome,
  onToggleLojaSelector,
  selectedDateISO,
  onSelectedDateChange,
}) => {
  const showDatePicker =
    onSelectedDateChange != null && selectedDateISO != null;

  return (
    <div className="fixed left-2 top-2 z-40 flex flex-wrap items-center gap-1.5 sm:left-4 sm:top-4 sm:gap-2">
      <button
        type="button"
        onClick={onGoHome}
        className="rounded-full bg-black/20 p-2.5 opacity-50 backdrop-blur-sm transition-all duration-200 hover:bg-black/40 hover:opacity-100 active:opacity-100 sm:p-2"
        title="Voltar ao início"
      >
        <Home size={20} className="text-white" />
      </button>
      {lojasCount > 0 && (
        <button
          type="button"
          onClick={onToggleLojaSelector}
          className="rounded-full bg-black/20 p-2.5 opacity-50 backdrop-blur-sm transition-all duration-200 hover:bg-black/40 hover:opacity-100 active:opacity-100 sm:p-2"
          title="Selecionar loja"
        >
          <Store size={20} className="text-white" />
        </button>
      )}
      {showDatePicker && (
        <label className="flex cursor-pointer items-center gap-1.5 rounded-full border border-white/15 bg-black/20 px-2.5 py-2 opacity-50 backdrop-blur-sm transition-all duration-200 hover:border-white/25 hover:bg-black/40 hover:opacity-100 has-[:focus-visible]:opacity-100 sm:px-3 sm:py-2">
          <Calendar
            size={18}
            className="shrink-0 text-yellow-200"
            aria-hidden
          />
          <input
            type="date"
            value={selectedDateISO}
            onChange={(e) => onSelectedDateChange(e.target.value)}
            className="h-5 w-[9.25rem] cursor-pointer bg-transparent text-xs text-white outline-none [color-scheme:dark] sm:h-5 sm:w-[9.75rem] sm:text-sm"
            aria-label="Selecionar data dos dados"
          />
        </label>
      )}
    </div>
  );
};
